import axios from './../plugins/private-api-axios'

export const settingService = {
    urlPrefix: '/settings',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getSettings (idName, id, group) {
        let urlBuilder = {
            'Group': group
        }

        urlBuilder[idName] = id

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async updateSettings (idName, id, group, settings) {
        let data = {
            group: group,
            settings: settings
        }

        data[idName] = id

        try {
            return await axios.put(`${this.urlPrefix}`, data, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateSettingService = (accessToken) => {
    settingService.config.headers.Authorization = accessToken
}

export default settingService
